module.exports = __webpack_public_path__ + "brand-img.svg?fb90d372036baa6ed9be3477f96690fd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-img.svg
// module id = 26
// module chunks = 0